import ArtifactGroupType from '@/roc/museum/base/ArtifactGroupType';
const ArtifactGroups = [
    {
        id: 1,
        name: 'Foundations of Civilization',
        icon: 'FoundationsOfCivilization',
        type: ArtifactGroupType.FOUNDATIONS_OF_CIVILIZATION,
    },
    {
        id: 2,
        name: 'Legends of the High Seas',
        icon: 'LegendsOfTheHighSeas',
        type: ArtifactGroupType.LEGENDS_OF_THE_HIGH_SEAS,
    },
    {
        id: 3,
        name: 'Treasures of the Nile',
        icon: 'TreasuresOfTheNile',
        type: ArtifactGroupType.TREASURES_OF_THE_NILE,
    },
    {
        id: 4,
        name: 'Whispers of Jade',
        icon: 'WhispersOfJade',
        type: ArtifactGroupType.WHISPERS_OF_JADE,
    },
    {
        id: 5,
        name: 'Echoes of the North',
        icon: 'EchoesOfTheNorth',
        type: ArtifactGroupType.ECHOES_OF_THE_NORTH,
    },
    {
        id: 6,
        name: 'Legends of Troy',
        icon: 'LegendsOfTroy',
        type: ArtifactGroupType.LEGENDS_OF_TROY,
    },
    {
        id: 7,
        name: 'Paths of Incense',
        icon: 'PathsOfIncense',
        type: ArtifactGroupType.PATH_OF_INCENSE,
    },
    {
        id: 8,
        name: 'Under the Ceiba',
        icon: 'UnderTheCeiba',
        type: ArtifactGroupType.UNDER_THE_CEIBA,
    },
];
export default ArtifactGroups;
